
<div class="row rowbg nopadding">
    <div class="panel-heading nopadding">
        <p>
            <button type="button" (mouseover)="reloadData('Total')" class="btn btn-primary  btn-xs defaultBtnColor">Total</button>
            <button type="button" (mouseover)="reloadData('Order')" class="btn btn-primary  btn-xs defaultBtnColor">ORDER</button>
            <button type="button" (mouseover)="reloadData('Trade')" class="btn btn-primary btn-xs defaultBtnColor">TRADE</button>
            <button type="button" (mouseover)="reloadData('Route')" class="btn btn-primary  btn-xs defaultBtnColor">ROUTE</button>
            <button type="button" (mouseover)="reloadData('CAT')" class="btn btn-primary btn-xs defaultBtnColor">CAT</button>
           </p>
      </div>
</div>
<div class="carousel carousel-showmanymoveone slide" id="carousel-tilenav" data-interval="false">
<div class="carousel-inner">
  <div class="panel panel-default nopadding">
    <div class=" panel-heading ">
       <p class=" panel-title" >
         Transaction Count</p>
        </div>
    <div class="panel-body nopadding"> 
     
    <canvas baseChart
            [data]="barChartData"
            [type]="'bar'"
            [options]="barChartOptions" 
            (chartHover)="chartHovered($event)"
            (chartClick)="chartClicked($event)">
    </canvas>
    </div>
  </div>
  </div>
  <a class="align-bottom left carousel-control" matTooltip="Prev" (click)="clickLeft()" data-slide="prev"><i class="glyphicon glyphicon-chevron-left"></i></a>
  <a class="align-bottom right carousel-control" matTooltip="Next" (click)="clickRight()" data-slide="next"><i class="glyphicon glyphicon-chevron-right"></i></a>
</div>